import React from 'react';
import { Button } from './ui/button';
import { toast } from 'sonner';
import { Link as LinkIcon, Share2 } from 'lucide-react';

/**
 * Compact Copy Link + Share controls. Shares the given `url` (absolute or relative)
 * or the current page URL when omitted.
 */
const ShareButtons = ({ url, title = 'I Need A Social Worker', text, size = 'sm', variant = 'outline', className = '', testidPrefix = 'share' }) => {
  const resolve = () => {
    if (!url) return window.location.href;
    return url.startsWith('http') ? url : `${window.location.origin}${url}`;
  };
  const copy = async (e) => {
    e?.preventDefault?.(); e?.stopPropagation?.();
    try { await navigator.clipboard.writeText(resolve()); toast.success('Link copied!'); }
    catch { toast.error('Could not copy link.'); }
  };
  const share = async (e) => {
    e?.preventDefault?.(); e?.stopPropagation?.();
    const data = { title, text: text || title, url: resolve() };
    if (navigator.share) { try { await navigator.share(data); } catch { /* cancelled */ } }
    else copy(e);
  };
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <Button type="button" size={size} variant={variant} onClick={copy} data-testid={`${testidPrefix}-copy`}>
        <LinkIcon className="w-4 h-4 mr-1" /> Copy Link
      </Button>
      <Button type="button" size={size} variant={variant} onClick={share} data-testid={`${testidPrefix}-share`}>
        <Share2 className="w-4 h-4 mr-1" /> Share
      </Button>
    </div>
  );
};

export default ShareButtons;
